var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFragResources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 32,
    viewBox: "0 0 160 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#6369D1",
    strokeWidth: 2,
    d: "M0 65L0 0 160 0 160 65"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42 16)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#6369D1",
    strokeWidth: 1.5,
    transform: "translate(2 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.923,
    cy: 6.462,
    r: 6.462
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.846 28.615v3.231h4.747L32.176 48h9.494l1.583-16.154H48V27c-.002-3.877-1.949-7.482-5.158-9.555-3.209-2.072-7.234-2.324-10.666-.665"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.923,
    cy: 12.923,
    r: 12.923
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.462 12.923L12.923 12.923 12.923 7.385M36.923 16.615L36.923 25.846M36.923 16.615L36.923 25.846"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragResources);
export default __webpack_public_path__ + "static/media/frag_resources.5ac980b358b11d2b577610f5c402fe2a.svg";
export { ForwardRef as ReactComponent };